module.exports = __webpack_public_path__ + "img/nicole-d-sconiers.f26d4ecd.png";